import { render, staticRenderFns } from "./DeptPerformanceCorrelationOverview.vue?vue&type=template&id=acbab5e0&scoped=true"
import script from "./DeptPerformanceCorrelationOverview.vue?vue&type=script&lang=js"
export * from "./DeptPerformanceCorrelationOverview.vue?vue&type=script&lang=js"
import style0 from "./DeptPerformanceCorrelationOverview.vue?vue&type=style&index=0&id=acbab5e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acbab5e0",
  null
  
)

export default component.exports